export class WebhookV1MPARequestNotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "string",
            "format": ""
        },
        {
            "name": "requesterEmail",
            "baseName": "requester_email",
            "type": "string",
            "format": ""
        },
        {
            "name": "policyDescription",
            "baseName": "policy_description",
            "type": "string",
            "format": ""
        },
        {
            "name": "approvalExpiresAt",
            "baseName": "approval_expires_at",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1MPARequestNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
